export const calculateZoomFactor = (
  mapW: number,
  mapH: number,
  containerW: number,
  containerH: number,
) => {
  const { isNaN } = Number;
  if (isNaN(mapW) || isNaN(mapH) || isNaN(containerW) || isNaN(containerH))
    return 0.2;
  const base = 1.1;
  const xFactor = (containerW * base) / mapW;
  const yFactor = (containerH * base) / mapH;
  return Math.min(xFactor, yFactor);
};

export const calculateTranslation = (
  mapW: number,
  mapH: number,
  containerW: number,
  containerH: number,
) => {
  const { isNaN } = Number;
  if (isNaN(mapW) || isNaN(mapH) || isNaN(containerW) || isNaN(containerH))
    return [0, 0];
  const zoomFactor = calculateZoomFactor(mapW, mapH, containerW, containerH);
  const newMapW = mapW * zoomFactor;
  const newMapH = mapH * zoomFactor;

  return [newMapW - containerW, newMapH - containerH].map((ele) => -ele / 2);
};
